import React from 'react';

import MenuItem from '~/components/core/Atomic/MenuItem';
import TextFieldFormik from '~/components/TextFieldFormik';
import useDataFetcher from '~/components/useDataFetcher';

type PhoneProfile = {
  id: number;
  name: string;
  is_default: boolean;
};

type PhoneProfilesResponse = {
  phone_profiles?: PhoneProfile[];
};

type Props = {
  organizationId?: number;
  isNew?: boolean;
};

export const PhoneProfileSelectFormik = ({ organizationId, isNew = false }: Props) => {
  const shouldFetch = !isNew && !!organizationId;
  const { data } = useDataFetcher(
    organizationId ? `/api/v1/organizations/${organizationId}/phone_profiles` : null,
    null,
    { shouldFetch, shouldReportAxiosError: false }
  );
  const phoneProfiles = (data as PhoneProfilesResponse | undefined)?.phone_profiles ?? [];

  if (isNew || phoneProfiles.length === 0) {
    return null;
  }

  return (
    <>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore TextFieldFormik children typing is too narrow for MenuItem lists */}
      <TextFieldFormik id="phone_profile_id" label="Phone Profile" fullWidth select>
        <MenuItem value="">Use Default Profile (follow org default)</MenuItem>
        {phoneProfiles.map((profile) => (
          <MenuItem key={profile.id} value={profile.id}>
            {profile.is_default ? `${profile.name} (pin even if org default changes)` : profile.name}
          </MenuItem>
        ))}
      </TextFieldFormik>
    </>
  );
};
